import { render, staticRenderFns } from "./FeedItemChangeStatus.vue?vue&type=template&id=881fb71a&scoped=true&"
import script from "./FeedItemChangeStatus.vue?vue&type=script&lang=js&"
export * from "./FeedItemChangeStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881fb71a",
  null
  
)

export default component.exports